// extracted by mini-css-extract-plugin
export default {"aboutUs":"styles_aboutUs__KkVWr","first":"styles_first__UA9pJ"};